import { useState } from 'react';
import { IconButton, MenuList, ListItemText, Divider, MenuItem } from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LanguageDropdownMenuMobile from './LanguageDropdownMenuMobile';
import OtherAppsAccordion from './OtherAppsAccordion';
import HeaderNavLink from '../HeaderNavLink';
import MoreInformationAccordion from './MoreInformationAccordion';
import LoginForm from '../LoginForm';
import Logo from '../Logo';
import RequestAccountDialog, { RequestAccountDialogButton } from '../RequestAccountDialog';
import { nav } from '../../../config';
import '../Header.scss';

function MobileHeader({ isLoggedIn }) {
  const [displayMenu, setDisplayMenu] = useState(false);
  const [requestAccountOpen, setRequestAccountOpen] = useState(false);
  return (
    <>
      <header className="header header--mobile">
        <nav className="header__container">
          <Logo isLoggedIn={isLoggedIn} />
          <LoginForm />
          <IconButton
            onClick={() => setDisplayMenu(true)}
            size="large"
            edge="start"
            aria-label="menu"
            sx={{ mr: 2, color: 'white' }}
          >
            <MenuIcon />
          </IconButton>
        </nav>
      </header>
      {displayMenu && (
        <div className="header__mobile-menu-list">
          <MenuList>
            <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
              <IconButton onClick={() => setDisplayMenu(false)} size="large" edge="start">
                <CloseIcon />
              </IconButton>
            </div>

            <div style={{ justifyContent: 'center', display: 'flex', paddingBottom: '10px' }}>
              <RequestAccountDialogButton
                onClick={() => {
                  setDisplayMenu(false);
                  setRequestAccountOpen(true);
                }}
              />
            </div>
            <MenuItem>
              <ListItemText>
                <HeaderNavLink
                  link="https://pro-news.globalforestwatch.org/"
                  label={nav.newsAndEvents}
                />
              </ListItemText>
            </MenuItem>
            <Divider />
            <MenuItem>
              <ListItemText>
                <HeaderNavLink link="/about" label="About" />
              </ListItemText>
            </MenuItem>
            <Divider />
            <MenuItem>
              <ListItemText>
                <HeaderNavLink
                  link="https://pro-news.globalforestwatch.org/users"
                  label={nav.users}
                />
              </ListItemText>
            </MenuItem>
            <Divider />
            <MenuItem>
              <ListItemText>
                <HeaderNavLink
                  link="https://www.globalforestwatch.org/blog/tag/gfw-pro"
                  label="Blog"
                />
              </ListItemText>
            </MenuItem>
            <Divider />
            <MenuItem>
              <ListItemText>
                <HeaderNavLink
                  link="https://www.globalforestwatch.org/help/gfw-pro/"
                  label="Help Center"
                />
              </ListItemText>
            </MenuItem>
            <Divider />
            <LanguageDropdownMenuMobile />
            <Divider />
            <OtherAppsAccordion />
            <Divider />
            <MoreInformationAccordion />
          </MenuList>
          <Divider />
        </div>
      )}
      <RequestAccountDialog open={requestAccountOpen} onOpenChange={setRequestAccountOpen} />
    </>
  );
}

export default MobileHeader;
